// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__E7iIV","validationTips":"StatementDescriptor_validationTips__jDpiv"};